import { render } from "./StripedTable.vue?vue&type=template&id=05c03d39"
import script from "./StripedTable.vue?vue&type=script&lang=ts"
export * from "./StripedTable.vue?vue&type=script&lang=ts"
script.render = render

export default script